import { render, staticRenderFns } from "./DashboardPendingTasksTable.vue?vue&type=template&id=366a8a49&scoped=true&"
import script from "./DashboardPendingTasksTable.vue?vue&type=script&lang=ts&"
export * from "./DashboardPendingTasksTable.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardPendingTasksTable.vue?vue&type=style&index=0&id=366a8a49&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366a8a49",
  null
  
)

export default component.exports